import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { TransferList } from '../components';

export default function Transfer({
  id,
  right,
  left,
  sending,
  close,
  insertData,
  removeData,
  visible,
}) {
  const [data, setData] = useState([]);
  const [disabled, setDisabled] = useState([]);

  useEffect(() => {
    if (sending) {
      insertData(data);
      removeData(disabled);
      close();
    }
  }, [sending, data, disabled]);

  return (
    <TransferList
      unique="idoperacao"
      label="codigonomeoperacao"
      id={id}
      onChangedItems={(values) => setData(values)}
      onDisabledItems={(values) => setDisabled(values)}
      listRight={right}
      listLeft={left}
      open={visible}
    />
  );
}

Transfer.propTypes = {
  id: PropTypes.number,
  right: PropTypes.arrayOf(PropTypes.any),
  left: PropTypes.arrayOf(PropTypes.any),
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  insertData: PropTypes.func.isRequired,
  removeData: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

Transfer.defaultProps = {
  id: -1,
  right: [],
  left: [],
};
